import api from 'dashboard/api/activationGuide';

const empty = () => ({
  eligible: false,
  loaded: false,
  messages: [],
  pending: false,
});

export default {
  namespaced: true,
  state: () => ({ accounts: {}, autoOpened: {} }),
  getters: {
    forAccount: state => accountId => state.accounts[accountId] || empty(),
    wasAutoOpened: state => accountId => !!state.autoOpened[accountId],
  },
  mutations: {
    set(state, { accountId, data }) {
      if (state.accounts[accountId]?.completed && data.eligible) return;
      state.accounts[accountId] = { ...data, loaded: true };
    },
    autoOpened(state, accountId) {
      state.autoOpened[accountId] = true;
    },
  },
  actions: {
    async fetch({ commit }, accountId) {
      try {
        const { data } = await api.get(accountId);
        commit('set', { accountId, data });
        return data;
      } catch (error) {
        if ([401, 402, 403, 404].includes(error.response?.status)) {
          commit('set', { accountId, data: empty() });
        }
        return null;
      }
    },
  },
};
